import { FilterDocumentDurationFilter } from '@griply/types';

export type DurationRange = Pick<FilterDocumentDurationFilter, 'more' | 'less'>;

// A typed range replaces the presence flags; an empty range preserves them.
export const applyDurationRange = (
  current: FilterDocumentDurationFilter | null | undefined,
  { more, less }: DurationRange,
): FilterDocumentDurationFilter | null => {
  if (more || less) {
    return { more: more ?? null, less: less ?? null };
  }

  if (current?.noDuration) {
    return { noDuration: true };
  }

  if (current?.hasDuration) {
    return { hasDuration: true };
  }

  return null;
};
